import React from 'react';
function DiagonallyExpandOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M7.69678 15.7677L14.7678 15.7677L14.7678 8.69666L7.69678 15.7677Z" })));
}
export default DiagonallyExpandOutlined;
